export const EDGE_FEATURE_BUCKET = { OUT_OF_STOCK_HERO: "oosRecsHero" };

export function showOutOfStockHero(edgeFeature, isInStock) {
  return !!(
    edgeFeature &&
    edgeFeature.bucket === EDGE_FEATURE_BUCKET.OUT_OF_STOCK_HERO &&
    isInStock === false
  );
}
